export default "__VITE_ASSET__K3vq0GA0__"